import * as React from 'react';
import { Book } from '../../../types/Book';
import '../Feed.css';
import Card from '../Card/Card';
import CollectionCard from '../../CollectionCard/CollectionCard';
import AdBlock from '../../AdBlock/AdBlock';

interface Props {
	books: Book[];
	loading?: boolean;
	limit?: number;
	onMoreLoad?: () => void;
	page?: number;
}

const FeedList: React.FC<Props> = ({ books, loading, limit, onMoreLoad, page }) => {
	const filteredBooks = React.useMemo(() => {
		if (books) {
			if (limit > 0) {
				return books.slice(0, limit);
			}
			
			return books;
		}

		return [];
	}, [limit, books]);

	return (
		<div>
			<div className="feed-content">
				{(!loading || page >= 1) &&
					filteredBooks.map((book, key) => (
						<Card toBookPage={true} book={book} key={book.id} />
					))}

				{loading &&
					[...new Array(8)].map((item) => (
						<Card dummy={true} book={{} as any} />
					))}
			</div>

			{!loading && page >= 0 && <CollectionCard header="Еще" action={onMoreLoad} imageURL="" />}
		</div>
	);
};

export default FeedList;
